var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32.516,
    height: 37.5,
    viewBox: "0 0 32.516 37.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1075",
    "data-name": "Group 1075",
    transform: "translate(883.612 -553.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1073",
    "data-name": "Group 1073"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1072",
    "data-name": "Group 1072"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1071",
    "data-name": "Group 1071"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_100",
    "data-name": "Line 100",
    x1: 14.141,
    y1: 0.001,
    transform: "translate(-866.5 568.398)",
    fill: "none",
    stroke: "#2699fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M-856.275,572.341l3.929-3.93-3.929-3.958",
    fill: "none",
    stroke: "#2699fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1074",
    "data-name": "Group 1074"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M-861.44,572.5v9.912h-9.839",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M-881.841,554.9l10.4,6.422v28.044l-10.92-6.948V554.368h20.921V564.5",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_101",
    "data-name": "Line 101",
    y2: 3.101,
    transform: "translate(-874.71 571.289)",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Logout.4808792d.svg";
export { ForwardRef as ReactComponent };